import {configureStore} from '@reduxjs/toolkit';
import {setupListeners} from '@reduxjs/toolkit/query';
// import {persistReducer, persistStore} from 'redux-persist';

// import AsyncStorage from '@react-native-async-storage/async-storage';

import {rootReducer} from './reducers';

// import AsyncStorage from '@react-native-async-storage/async-storage';
// import {rootTransforms} from '../utils/rootTransforms';

// const persistConfig = {
//   key: 'root',
//   storage: AsyncStorage,
//   // transforms: [rootTransforms],
//   // whitelist: [
//   //   userApi.reducerPath,
//   //   // 'mission',
//   //   // missionApi.reducerPath,
//   //   // basicRegisterApi.reducerPath,
//   //   // localPouchDBApi.reducerPath,
//   //   // 'user',
//   //   // remoteCouchDBApi.reducerPath,
//   // ],
// };

// const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  // reducer: persistedReducer,
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    })
});

// export const persistor = persistStore(store);

setupListeners(store.dispatch);
